// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__329yt","vLegacy":"SelectSecondary_vLegacy__1xmTI","error":"SelectSecondary_error__29gre","disabled":"SelectSecondary_disabled__2ZWDl"};